import _ from "lodash";
import { SYMPTOM_UNITS_NEW, FOOD_UNITS, PCP_UNITS, DRUG_UNITS, SUP_UNITS, ACTIVITY_UNITS, LOC_UNITS } from "../actions/constant";
import {
  logout
} from "../services/AuthenticationService";
import moment from "moment";

export const checkInput = (input, unit) => {
  if (!input) {
    return true;
  }

  // ✅ Skip pattern validation if unit is HH:MM (445)
  if (unit === "445") {
    return true;
  }

  const trimmedInput = input.trim();

  // Valid patterns:
  // - Integer: 1
  // - Decimal: 1.5
  // - Simple Fraction: 1/2
  // - Mixed Fraction (ampersand or space): 1&1/2, 1 1/2
  const validPattern = /^(\d+(\.\d*)?|\d+\/\d+|\d+&\d+\/\d+|\d+ \d+\/\d+)$/

  // Reject cases where denominator is zero (e.g. 3/0, 2&3/0, 2 3/0)
  const zeroDenominatorPattern = /\/0+(?=\D|$)/;

  return validPattern.test(trimmedInput) && !zeroDenominatorPattern.test(trimmedInput);

};

export const logoutRedirect = () => {
  // Add your logout logic here (e.g., clearing tokens, redirecting to login page)
  logout();
  localStorage.removeItem('token'); // Example: Remove a token from local storage
  window.location.href = '/login'; // Example: Redirect to the login page
};

export const formatNumber = (value) => {
  if (value >= 1000) {
    return (value / 1000).toFixed(1) + 'K';
  }
  return value.toString();
}

export function shouldHidePost(data) {
  if (data && data.relevant && data.relevant.up + data.relevant.down >= 100) {
    const totalVotes = data.relevant.up + data.relevant.down;
    const upvotePercentage = (data.relevant.up / totalVotes) * 100;

    return upvotePercentage <= 20;
  }
  return false;
};

export function debounce(func, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
}

export const handleAmountValue = (fractionString) => {
  if (fractionString < 0) {
    return fractionString;
  } else {
    fractionString = fractionString && fractionString.toString().trim().replace('&', ' ');
  }
  const simpleFractionRegex = /^(\d+)\/(\d+)$/;

  let result = NaN;
  if (simpleFractionRegex.test(fractionString)) {
    const match = fractionString.match(simpleFractionRegex);
    const numerator = parseInt(match[1]);
    const denominator = parseInt(match[2]);
    result = numerator / denominator;
  } else if (/[\/ .&]$/.test(fractionString)) {
    result = fractionString.replace(/[\/ .&]$/, '');
  } else {
    result = fractionString;
  }

  return result;
};

export function getItemUnitsList(item_units, category_units) {
  let measurementOptions = [];
  let unitid = "";
  if (item_units && item_units.length > 0) {
    if (item_units.length === 1 && parseInt(item_units[0]) !== 910) {
      unitid = item_units[0];
      category_units.map((unit) => {
        if (parseInt(unit._id) === parseInt(item_units[0])) {
          measurementOptions.push({ value: unit._id, label: unit.unit });
        }
      })

    } else if (item_units.length === 1 && parseInt(item_units[0]) === 910) {
      category_units.map((unit) => {
        if (unit._id !== "135" && unit._id !== "125") {
          measurementOptions.push({ value: unit._id, label: unit.unit });
        }
      })
    } else {
      category_units.map((unit) => {
        if (item_units.includes(unit._id.toString())) {
          measurementOptions.push({ value: unit._id, label: unit.unit });
        }
      })
    }
  } else {
    category_units.map((unit) => {
      measurementOptions.push({ value: unit._id, label: unit.unit });
    })
  }

  return [measurementOptions, unitid]
}

export const handleUnitDropdown = (category, item, is_search = false) => {
  const unitList = item.unitList || item.units || item.unit || item.unitsid || [];
  let unitOptions = [];
  let act_units = [];

  // Step 1: Get full unit list based on category
  if (category === "01") {
    act_units = SYMPTOM_UNITS_NEW();
  } else if (category === "02" || category === "999") {
    act_units = FOOD_UNITS();
  } else if (category === "04") {
    act_units = PCP_UNITS();
  } else if (category === "05") {
    act_units = DRUG_UNITS();
  } else if (category === "06") {
    act_units = SUP_UNITS();
  } else if (category === "03") {
    act_units = ACTIVITY_UNITS();
  } else if (category === "07") {
    act_units = LOC_UNITS();
  }

  // Step 2: Filter or use full list based on unitList
  if (!unitList.length) { // If unitList is an empty array or undefined/null (typically for New Custom Activity)
    act_units = act_units
    if (category == "03" && is_search) {
      const unitsToExclude = ['103', '104']; // Exclude "Distance Units"
      act_units = _.reject(act_units, item => unitsToExclude.includes(item._id));
    }
  } else if ((category == "02" || category == "999") && unitList.length && unitList[0] == "910") { // If unitList is "910"
    const unitsToExclude = ['125', '135']; // Exclude "Serving" & "Each"
    act_units = _.reject(act_units, item => unitsToExclude.includes(item._id));
  } else if (unitList.length) {
    const unitsToInclude = unitList; // Otherwise, include all units sent by Backend
    act_units = _.filter(act_units, item => unitsToInclude.includes(item._id));
  }

  // Step 3: Build unitOptions from filtered list
  unitOptions = act_units.map(unit => ({
    value: unit._id,
    label: unit.unit,
  }));

  // Step 4: Special case — include unit "Hour:Minute" if "Hour" is present for categories 03 or 07
  if (
    (category === "03" || category === "07") &&
    unitOptions.some(u => u.value === "102") &&
    !unitOptions.some(u => u.value === "445")
  ) {
    const unit445 = act_units.find(u => u._id === "445") || // might be excluded above
      (category === "03" ? ACTIVITY_UNITS() : LOC_UNITS()).find(u => u._id === "445");

    if (unit445) {
      unitOptions.push({ value: unit445._id, label: unit445.unit });
    }
  }

  return unitOptions;
}

export function getNameWithKey(key, item) {
  if (key === "name" || key === "sName") {
    if (item.name) {
      return item.name
    } else if (item.recipe) {
      return item.recipe
    } else if (item.recipes) {
      return item.recipes
    } else if (item.title) {
      return item.title
    }
  } else if (key === "displayname") {
    if (item.displayname) {
      return item.displayname
    } else if (item.name) {
      return item.name
    } else if (item.recipe) {
      return item.recipe
    } else if (item.recipes) {
      return item.recipes
    } else if (item.title) {
      return item.title
    }
  } else if (key === "fullname" || key === "full_name") {
    if (item.fullname) {
      return item.fullname
    } else if (item.recipe_full) {
      return item.recipe_full
    } else if (item.title) {
      return item.title
    } else if (item.name) {
      return item.name
    } else if (item.recipe) {
      return item.recipe
    } else if (item.recipes) {
      return item.recipes
    }
  }
}
export const getScaleList = (item_units) => {
  if (typeof (item_units) == "string") {
    item_units = [item_units]
  }
  let act_units = [];
  let scaleList = [];
  let newUnits = [];
  act_units = SYMPTOM_UNITS_NEW();
  item_units = item_units || [];
  act_units.map(item => {
    for (let index = 0; index < item_units.length; index++) {
      if (item_units[index] == item._id) {
        newUnits.push({
          value: item._id,
          label: item.unit,
        });
      }
    }
    return newUnits;
  });
  if (newUnits.length === 1) {
    for (const sunit of act_units) {
      if (newUnits[0].value == sunit._id) {
        if (sunit.label) {
          for (let index = 0; index < sunit.value.length; index++) {
            scaleList.push({
              value: sunit.value[index],
              label: sunit.label[index],
            });
          }
        } else {
          scaleList = [];
          scaleList.desc = sunit.description;
        }
      }
    }
    return scaleList;

  } else {
    for (const sunit of act_units) {
      if (newUnits.value == sunit._id)
        if (sunit.label) {
          for (let index = 0; index < sunit.value.length; index++) {
            scaleList.push({
              value: sunit.value[index],
              label: sunit.label[index],
            });
          }
        }
        else {
          scaleList = [];
          scaleList.desc = sunit.description;
          return scaleList;
        }
    }
    return scaleList;
  }
}

// Central Helper to identify whether the item is a Contributed Item or Not (applicable for is_own true or false)
export function isContributedItem(symptomForm) {
  const id = symptomForm && symptomForm.symptom;
  const upc = symptomForm && symptomForm.upc;
  return (
    id &&
    id.charAt(0) !== "1" &&   // ✅ ID does not start with 1
    !!upc                     // ✅ upc exists                
  );
}

// Central Helper to get TAS Name from Backend
export function getTASNameFromItem(item) {
  if (!item || typeof item !== 'object') return '';

  const category = String(item.category);

  if (category === '02') {
    return item.recipe_full || '';
  } else if (['03', '04', '05', '06', '07'].includes(category)) {
    return item.fullname || '';
  } else if (category === '01') {
    return item.name || '';
  } else {
    return item.recipe_full || item.fullname || item.name || '';
  }
}

// Central Helper to get Display Name from Backend
export function getDisplayNameFromItem(item) {
  if (!item || typeof item !== 'object') return '';

  const category = String(item.category);

  if (category === '02') {
    return item.recipe || '';
  } else if (['03', '04', '05', '06', '07'].includes(category)) {
    return item.name || '';
  } else if (category === '01') {
    return item.displayname || '';
  } else {
    return item.recipe || item.displayname || item.title || item.name || '';
  }
}

export function checkUnitMeasurement(category, id, upc) {
  if (
    (category !== "07" &&
      category !== "01" &&
      (category === "02" ||
        category === "03" ||
        category === "999") &&
      !id) ||
    category === "04" ||
    category === "05" ||
    category === "06" ||
    ((category === "02" ||
      category === "03" ||
      category === "999") &&
      upc)
  ) {
    return true;
  } else {
    return false;
  }
}

// Convert "HH;MM" to hours or minutes based on HH value for Backend saving purpose
export function convertHHMMForBackend(scale, unit) {

  if (unit !== "445" || typeof scale !== "string" || !scale.includes(";")) {
    return { scale, unit }; // No conversion
  }

  const [hh, mm] = scale.split(";").map(Number);
  if (isNaN(hh) || isNaN(mm)) {
    return { scale, unit }; // No conversion
  }

  return hh >= 3
    ? { scale: (hh + mm / 60).toString(), unit: "102" }  // Convert to hour
    : { scale: (hh * 60 + mm).toString(), unit: "101" }; // Convert to minute
}

/**
 * Convert hour values to HH;MM (unit 445) for DISPLAY — per spec:
 * - Only applies when unit is hours (102)
 * - If value is whole number (e.g. "4") OR a fraction string (e.g. "100/2") → NO conversion
 * - If value is decimal AND numeric value >= 3 → convert to "H;MM" (semicolon);
 *   minutes have no rounding (we only correct FP noise), and are zero-padded if integer < 10.
 * - For all other cases (including minutes 101) → NO conversion
 *
 * Returns:
 *   { display, unit, backendUnit, backendScale }
 * Where:
 *   - display: what to show in the list/UI ("H;MM" or original string)
 *   - unit: display unit id ("445" if converted, else original unit)
 *   - backendUnit: original unit to send on save (kept as "102" for hours)
 *   - backendScale: original value string to send on save
 */
export function convertHHMMForDisplay(scale, unit) {
  var unit = String(unit || "");
  var scale = String(scale || "").trim();

  // default passthrough (no conversion)
  const passthrough = {
    display: scale,
    unit,
    backendUnit: unit,
    backendScale: scale,
  };

  // Only hours (102) are candidates
  if (unit !== "102") return passthrough;
  if (!scale) return passthrough;

  // Fractions → NO conversion
  if (scale.includes("/")) return passthrough;

  // Must be a numeric string
  const num = Number(scale);
  if (!isFinite(num)) return passthrough;

  // Whole numbers (incl. 3.0) → NO conversion
  const isWhole = Math.abs(num - Math.round(num)) < 1e-9;
  if (isWhole) return passthrough;

  // Decimal hours < 3 → NO conversion
  if (num < 3) return passthrough;

  // Convert decimal hours to HH;MM
  const hours = Math.floor(num);
  if (hours >= 100) return passthrough;

  // Get fractional hour part
  const fractional = num - hours;
  // Convert fractional hours to minutes, correcting floating error without rounding intent
  const minutesFloat = fractional * 60; // e.g., 0.5 -> 30, 0.25 -> 15
  // Normalize tiny FP noise (e.g., 29.999999 -> 30)
  const minutesRound = Math.round(minutesFloat * 1000000) / 1000000;
  const minutesFixed = Math.floor(minutesRound + 1e-9); // e.g., 19.8 → 19; 29.999999 → 29

  // 2-digit minutes
  var minutes = minutesFixed < 10 ? ("0" + minutesFixed) : String(minutesFixed);

  return {
    display: `${hours};${minutes}`, // semicolon format, hours not zero-padded
    unit: "445",                  // switch display unit to HH;MM
    backendUnit: "102",           // keep original hour unit for payload
    backendScale: scale,            // keep original hour value for payload
  };
}

// Assign converted "HH;MM" to payload before saving
export function prepareForBackend(showList) {
  return showList.map(user => ({
    ...user,
    inputs: (user.inputs || []).map(item => ({
      ...item,
      scale: item.backendScale || item.scale,
      unit: item.backendUnit || item.unit,
    })),
  }));
}

export function detectItemChanged(form, selected) {
  if (!selected.name) return false;

  const isSame =
    (form.category || "").toString().trim() === (selected.category || "").toString().trim() &&
    (form.name || "").trim() === (selected.name || "").trim() &&
    (form.symptom || "") === (selected.symptom || "") &&
    (form.scale || "").toString().trim() === (selected.scale || "").toString().trim() &&
    (form.unit || "").toString().trim() === (selected.unit || "").toString().trim() &&
    moment(form.time).unix() === moment(selected.time).unix() &&
    (form.comment || "").trim() === (selected.comment || "").trim();

  return !isSame;
}

export function detectIngredientChanged(form, selected) {
  if (!selected.recipe_full) return false;

  const isSame =
    (form.recipe_full || "").trim() === (selected.recipe_full || "").trim() &&
    (form._id || "") === (selected._id || "") &&
    (form.size || "").toString().trim() === (selected.size || "").toString().trim() &&
    (form.unitid || "").toString().trim() === (selected.unitid || "").toString().trim()

  return !isSame;
}
export function SetupPageWithBFCacheAndPrompt(
  componentInstance,
  {
    promptRefName = "ProductNotContributed",
    initCallback,
    // NEW: which storage key to keep in sync
    dirtyFlagKey = "previousPageIsDirty",
    // NEW: optional callback if you want to react in the page when the flag flips
    onDirtyFlagChange, // (exists: boolean, meta: { source, freshValue, navType }) => void

  } = {}
) {
  let lastPromptTime = 0;

  // --- helpers ---------------------------------------------------------------

  function normalizeDirtyFlag(source = "") {
    // Re-read from storage NOW (don’t trust any memoized value in page memory)
    const fresh = sessionStorage.getItem(dirtyFlagKey);
    const exists = !(fresh === null || fresh === "null" || fresh === "" || fresh === "false");

    // If effectively cleared, also scrub any legacy/localStorage copy to avoid ghosts
    if (!exists) {
      try { localStorage.removeItem(dirtyFlagKey); } catch (e) {}
    }

    if (typeof onDirtyFlagChange === "function") {
      const navEntries = performance.getEntriesByType("navigation");
      const navType = navEntries.length > 0 ? navEntries[0].type : "";
      onDirtyFlagChange(exists, { source, freshValue: fresh, navType });
    }
  }

  // ✅ Handles the uncontributed product prompt
  function checkUnContributed(source = "") {
    const contributionCanceled = localStorage.getItem("unContributed");
    const now = Date.now();

    if (contributionCanceled === "true" && now - lastPromptTime > 500) {
      // Trigger prompt if ref exists
      if (componentInstance[promptRefName]) {
        componentInstance[promptRefName].changeStatus();
      }
      lastPromptTime = now;
    }
  }

  // ✅ Handles Safari/Firefox BFCache restoration
  function handlePageShow(event) {
    const navEntries = performance.getEntriesByType("navigation");
    const navType = navEntries.length > 0 ? navEntries[0].type : "";
    const restored = event.persisted || navType === "back_forward";

    // 🔐 If we just came back from Contribute (Cancel path sets this),
    //     force-clear the stale dirty flag BEFORE re-reading storage.
    if (localStorage.getItem("unContributed") === "true") {
      try { sessionStorage.removeItem(dirtyFlagKey); } catch (e) {}
    }

    if (restored) {
      // 1) force a fresh read of sessionStorage + normalize
      normalizeDirtyFlag("pageshow");
      // 2) your existing prompt logic
      checkUnContributed("pageshow");
      // 3) let the page re-run its init
      if (typeof initCallback === "function") initCallback();
    } else {
      // Non-BFCache navigation still benefits from a fresh read
      normalizeDirtyFlag("pageshow(non-bfcache)");
      checkUnContributed("pageshow(non-bfcache)");
    }
    //   console.log("[SafariFix] BFCache restore detected → reinitializing page");
    //   if (typeof initCallback === "function") {
    //     initCallback();
    //   }
    // }
    // checkUnContributed("pageshow");
  }

  // Some Firefox/Safari edge cases only fire visibilitychange; cheap extra safety
  function handleVisibility() {
    if (document.visibilityState === "visible") {
      if (localStorage.getItem("unContributed") === "true") {
        try { sessionStorage.removeItem(dirtyFlagKey); } catch (e) {}
      }

      normalizeDirtyFlag("visibilitychange");
    }
  }

  // --- initial run (fresh mount) --------------------------------------------
  normalizeDirtyFlag("initial mount");
  checkUnContributed("initial mount");
  if (typeof initCallback === "function") initCallback(); // run immediately on mount


  // --- listeners -------------------------------------------------------------
  // ✅ Attach pageshow for Safari/Firefox BFCache
  window.addEventListener("pageshow", handlePageShow);
  document.addEventListener("visibilitychange", handleVisibility);


  // ✅ Return cleanup for componentWillUnmount
  return () => {
    window.removeEventListener("pageshow", handlePageShow);
    document.removeEventListener("visibilitychange", handleVisibility);
  };
}

export function isZeroEquivalent(scale) {
  if (!scale || typeof scale !== "string") return true; // covers "", null, undefined

  const trimmed = scale.trim();

  // Zero equivalent HH:MM format
  const isZeroTimeFormat = /^0{1,2};0{1,2}$/.test(trimmed);
  if (isZeroTimeFormat) return true;

  // Matches 0, 0., 0.0, 000, 000.000, 0/2 etc. but NOT 0 0, 0/ or 0&1
  // const zeroEquivalentPattern = /^(?:[0.]*0+(?:\s*\/\s*[1-9]\d*)?|(?:[0.]*0+\s*(?:[& ]+\s*0+)+\s*\/\s*[1-9]\d*))$/;
  const zeroEquivalentPattern = /^(?:0*\.?0*\.?|0*(?:[& ]+0+)*\s*\/\s*[1-9]\d*)$/
  return zeroEquivalentPattern.test(trimmed);
}

/**
 * One factory that returns everything you need for an amount <input>.
 * mode: 'fraction' (default) or 'decimal'
 */
export function AmountHandlers(mode = "fraction") {

  // This regex validates a number-like string that:
  // - Starts with a digit
  // - May contain only one of each: '/', '.', '&', or space
  // - Disallows two or more of those characters in a row
  // - Prevents mixed usage of '.' with '/', '&', or space
  // - Ensures no '&' comes after or before a space
  // - Allows formats like "1/2", "2.5", "3 & 1", "4 1/2", but not "1//2", "2.5/1", "1 & 2", or "1 2&3"
  const fractionRegex = /^(?!.*[\/.& ]{2,})(?!.*([\/.& ])(?=.*\1))(?!.*\..*[\/& ])(?!.*[\/& ].*\.)((?!.*&.* ).*)(?!.* .*&)^([0-9][0-9\/.& ]*)$/;

  // Matches a numeric string that:
  // - Starts with a digit
  // - May contain only one optional decimal point
  // - Allows digits after the decimal (or none)
  // - Disallows strings starting with '.' or having multiple dots
  const decimalOnlyRegex = /^[0-9]+(?:\.[0-9]*)?$/;

  const re = mode === "decimal" ? decimalOnlyRegex : fractionRegex;

  const isValid = (s) => s === "" || re.test(s);

  const sanitize = (raw) => {
    let out = "";
    const text = String(raw || "");
    for (let i = 0; i < text.length; i++) {
      const cand = out + text[i];
      if (isValid(cand)) out = cand;
    }
    return out;
  };

  const computeNext = (current, insert, selStart, selEnd) => {
    const next = current.slice(0, selStart) + insert + current.slice(selEnd);
    return { next, accept: isValid(next) };
  };

  // Event helpers (framework-agnostic)
  const onBeforeInput = (current, data, selStart, selEnd) => {
    if (data == null) return true; // IME etc.
    return computeNext(current, data, selStart, selEnd).accept;
  };

  const onChange = (raw) => sanitize(raw);

  const onPaste = (current, pasteText, selStart, selEnd) => {
    const cleaned = sanitize(pasteText);
    return current.slice(0, selStart) + cleaned + current.slice(selEnd);
  };

  return { isValid, sanitize, onBeforeInput, onChange, onPaste };
}

// Parse "1 & 1/2", "1 1/2", "1/2", "2.75", "-1/2", "-1 1/2", etc.
export function parseFractionalNumber(input) {
  if (input == null) return NaN;
  const s = String(input).trim();
  if (!s) return NaN;

  // Mixed fraction: "-1 & 1/2" or "-1 1/2"
  let m = s.match(/^(-?\d+)\s*(?:&|\s)\s*(\d+)\s*\/\s*(\d+)$/);
  if (m) {
    const whole = parseInt(m[1], 10);
    const numerator = parseInt(m[2], 10);
    const denominator = parseInt(m[3], 10);
    if (denominator === 0) return NaN;

    const absWhole = Math.abs(whole);
    const val = absWhole + numerator / denominator;
    return whole < 0 ? -val : val;
  }

  // Simple fraction: "-1/2" or "3/4"
  m = s.match(/^(-?\d+)\s*\/\s*(\d+)$/);
  if (m) {
    const numerator = parseInt(m[1], 10);
    const denominator = parseInt(m[2], 10);
    if (denominator === 0) return NaN;
    return numerator / denominator;
  }

  // Plain number
  const n = Number(s);
  return Number.isFinite(n) ? n : NaN;
}

/**
 * Compress an image File to be <= maxBytes (default 1MB).
 * - Tries lowering JPEG quality first, then gradually downsizes dimensions.
 * - Returns the original File if it's already small or if compression doesn't help.
 *
 * @param {File} file
 * @param {Object} opts
 * @param {number} opts.maxBytes - size ceiling in bytes
 * @param {string} opts.mimeType - output image type (jpeg recommended)
 * @param {number} opts.qualityStart - initial JPEG quality
 * @param {number} opts.qualityFloor - lowest quality before downscaling
 * @param {number} opts.downscaleStep - dimension multiplier when downscaling
 * @param {number} opts.minWidth - do not go below this width
 * @param {number} opts.minHeight - do not go below this height
 * @returns {Promise<File>}
 */
export async function compressImageToLimit(
  file,
  {
    maxBytes = 1000000,        // 1 MB
    mimeType = "image/jpeg",
    qualityStart = 0.9,        // start high
    qualityFloor = 0.7,        // don’t go below 0.7 unless you must
    downscaleStep = 0.9,       // shrink 10% only when needed
    minWidth = 800,            // don’t drop below 800px wide
    minHeight = 800,           // don’t drop below 800px high
  } = {}
) {
  try {
    if (!file || !(file instanceof File)) return file;
    if (file.size <= maxBytes) return file;

    const readAsDataURL = (f) =>
      new Promise((res, rej) => {
        const fr = new FileReader();
        fr.onload = () => res(fr.result);
        fr.onerror = rej;
        fr.readAsDataURL(f);
      });

    const loadImage = (src) =>
      new Promise((res, rej) => {
        const img = new Image();
        img.onload = () => res(img);
        img.onerror = rej;
        img.src = src;
      });

    const toBlob = (canvas, type, quality) =>
      new Promise((res) => {
        // Some browsers may return null if they can't encode; guard for that.
        canvas.toBlob((blob) => res(blob), type, quality);
      });

    const dataUrl = await readAsDataURL(file);
    let img = await loadImage(dataUrl);

    // Prepare canvas
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = img.width;
    canvas.height = img.height;

    let quality = qualityStart;
    let bestBlob = null;

    // Attempt quality reduction first, then downscale, up to a reasonable number of tries
    for (let attempts = 0; attempts < 10; attempts++) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      let blob = await toBlob(canvas, mimeType, quality);
      if (blob && (!bestBlob || blob.size < bestBlob.size)) {
        bestBlob = blob;
      }

      if (blob && blob.size <= maxBytes) {
        bestBlob = blob;
        break;
      }

      // Reduce quality until we hit floor
      if (quality > qualityFloor) {
        quality = Math.max(qualityFloor, quality - 0.1);
        continue;
      }

      // Downscale dimensions a bit (preserve aspect ratio)
      const nextW = Math.max(minWidth, Math.round(canvas.width * downscaleStep));
      const nextH = Math.max(minHeight, Math.round(canvas.height * downscaleStep));

      // If we cannot shrink further, stop
      if (nextW === canvas.width && nextH === canvas.height) break;

      canvas.width = nextW;
      canvas.height = nextH;
      // Slightly bump quality back up after downscale to protect detail
      quality = Math.min(0.8, quality + 0.05);
    }

    // If we produced a smaller blob than original, wrap it as a File
    if (bestBlob && bestBlob.size < file.size) {
      // Keep original name but switch extension to .jpg if needed
      const newName = file.name.replace(/\.[^.]+$/, ".jpg");
      return new File([bestBlob], newName, { type: mimeType });
    }

    return file; // fallback: send original if compression didn't help
  } catch (e) {
    // Fail-safe: never block uploads
    // eslint-disable-next-line no-console
    console.warn("[image] compression failed; sending original file", e);
    return file;
  }
}



// Version 1
// /**
//  * Compress an image to <= maxBytes (default 1 MB) efficiently:
//  * 1) Fast quality fit (2-sample model + small refinement) at current dimensions.
//  * 2) If that would require too-low quality, predictively downscale (sqrt ratio), then re-fit quality.
//  * Never returns the original if it's above maxBytes (barring catastrophic errors).
//  *
//  * Notes:
//  * - Preserves aspect ratio when downscaling.
//  * - Avoids unnecessary quality loss by fitting at current size first.
//  * - Uses minimal re-encodes thanks to fast fit + predictive scaling.
//  *
//  * @param {File} file
//  * @param {Object} opts
//  * @param {number} [opts.maxBytes=1000000]
//  * @param {string} [opts.mimeType="image/jpeg"]   // set "image/webp" if you prefer (keeps alpha)
//  * @param {number} [opts.qualityHigh=0.92]       // upper bound for quality search
//  * @param {number} [opts.qualityLow=0.6]         // preferred minimal quality before we prefer downscaling
//  * @param {number} [opts.qualityMin=0.4]         // absolute floor in worst case
//  * @param {number} [opts.minWidth=600]
//  * @param {number} [opts.minHeight=600]
//  * @param {boolean} [opts.keepAlpha=false]       // if true and source has alpha, switch to WebP
//  * @returns {Promise<File>}
//  */
// export async function compressImageSmart(
//   file,
//   {
//     maxBytes = 1000000,
//     mimeType = "image/jpeg",
//     qualityHigh = 0.92,
//     qualityLow = 0.6,
//     qualityMin = 0.4,
//     minWidth = 600,
//     minHeight = 600,
//     keepAlpha = false,
//   } = {}
// ) {
//   // --- Small helpers --------------------------------------------------------
//   const readAsDataURL = (f) =>
//     new Promise((res, rej) => {
//       const fr = new FileReader();
//       fr.onload = () => res(fr.result);
//       fr.onerror = rej;
//       fr.readAsDataURL(f);
//     });

//   const loadHTMLImage = (src) =>
//     new Promise((res, rej) => {
//       const img = new Image();
//       img.decoding = "async";
//       img.onload = async () => {
//         try { if (img.decode) await img.decode(); } catch (e) { /* Safari may throw on decode after load; ignore */ }
//         res(img);
//       };
//       img.onerror = rej;
//       img.src = src;
//     });

//   const toBlob = (canvas, type, quality) =>
//     new Promise((res) => canvas.toBlob((b) => res(b), type, quality));

//   const hasAlphaType = (type) => /png|webp/i.test(type);
//   const extFor = (type) =>
//     type === "image/webp" ? ".webp" :
//     type === "image/png"  ? ".png"  :
//     ".jpg";

//   const bytesHuman = (n) => (n >= 1e6 ? (n / 1e6).toFixed(2) + " MB" : (n / 1e3).toFixed(2) + " KB");
//   const nowMs = () => (typeof performance !== "undefined" && performance.now ? performance.now() : Date.now());

//   // Check if canvas looks blank/black by sampling a few points.
//   function isLikelyBlank(canvas) {
//     const w = canvas.width, h = canvas.height;
//     if (!w || !h) return true;
//     const ctx = canvas.getContext("2d", { willReadFrequently: true });
//     const pts = [
//       [w >> 1, h >> 1],
//       [1, 1],
//       [w - 2, 1],
//       [1, h - 2],
//       [w - 2, h - 2],
//     ];
//     for (const [x, y] of pts) {
//       const d = ctx.getImageData(Math.max(0, x), Math.max(0, y), 1, 1).data;
//       // Non-transparent and not pure black?
//       if (d[3] !== 0 && (d[0] + d[1] + d[2]) !== 0) return false;
//     }
//     return true;
//   }

//   // Predictive scale factor using size ratio; size ∝ pixels * quality-ish
//   function predictedScale(currentBytes, targetBytes) {
//     const ratio = Math.max(0.01, Math.min(1, targetBytes / currentBytes));
//     return Math.sqrt(ratio) * 0.98; // slight undershoot to avoid oscillation
//   }

//   // Downscale canvas preserving aspect ratio with floor guards and high-quality smoothing.
//   function downscaleCanvas(canvas, scale, minW, minH) {
//     const nextW = Math.max(minW, Math.floor(canvas.width * scale));
//     const nextH = Math.max(minH, Math.floor(canvas.height * scale));
//     if (nextW === canvas.width && nextH === canvas.height) return false;

//     const tmp = document.createElement("canvas");
//     tmp.width = nextW;
//     tmp.height = nextH;
//     const tctx = tmp.getContext("2d");
//     tctx.imageSmoothingEnabled = true;
//     tctx.imageSmoothingQuality = "high";
//     tctx.drawImage(canvas, 0, 0, nextW, nextH);

//     canvas.width = nextW;
//     canvas.height = nextH;
//     const ctx = canvas.getContext("2d");
//     ctx.imageSmoothingEnabled = true;
//     ctx.imageSmoothingQuality = "high";
//     ctx.clearRect(0, 0, nextW, nextH);
//     ctx.drawImage(tmp, 0, 0, nextW, nextH);
//     return true;
//   }

//   // Classic binary-search quality fitter (used as a refinement)
//   async function fitByQuality(canvas, type, qLo, qHi, targetBytes, epsilonBytes = 8192) {
//     let best = null;
//     let lo = qLo, hi = qHi;

//     let blob = await toBlob(canvas, type, hi);
//     if (blob && blob.size <= targetBytes) return { blob, quality: hi };
//     if (blob) best = blob;

//     while (hi - lo > 0.005) {
//       const mid = (hi + lo) / 2;
//       blob = await toBlob(canvas, type, mid);
//       if (!blob) break;

//       if (!best || blob.size < best.size) best = blob;

//       if (Math.abs(blob.size - targetBytes) <= epsilonBytes) {
//         return { blob, quality: mid };
//       }
//       if (blob.size > targetBytes) hi = mid; else lo = mid;
//     }
//     return { blob: best, quality: (hi + lo) / 2 };
//   }

//   // Fast quality fit using 2 samples + log-linear model; falls back as needed
//   async function fitByQualityFast(canvas, type, qLo, qHi, targetBytes, epsilonBytes = 8192) {
//     const q1 = Math.min(qHi, 0.88);
//     const q2 = Math.max(qLo, 0.60);

//     const b1 = await toBlob(canvas, type, q1);
//     if (b1 && b1.size <= targetBytes) return { blob: b1, quality: q1 };

//     const b2 = await toBlob(canvas, type, q2);
//     if (!b1 || !b2 || b1.size === b2.size) {
//       return fitByQuality(canvas, type, qLo, qHi, targetBytes, epsilonBytes);
//     }

//     const m = (Math.log(b2.size) - Math.log(b1.size)) / (q2 - q1);
//     const c = Math.log(b1.size) - m * q1;

//     let qStar = (Math.log(targetBytes) - c) / m;
//     qStar = Math.max(qLo, Math.min(qHi, qStar));

//     let bStar = await toBlob(canvas, type, qStar);
//     if (bStar && Math.abs(bStar.size - targetBytes) <= epsilonBytes) {
//       return { blob: bStar, quality: qStar };
//     }

//     const delta = 0.08;
//     const lo = Math.max(qLo, qStar - delta);
//     const hi = Math.min(qHi, qStar + delta);
//     return fitByQuality(canvas, type, lo, hi, targetBytes, epsilonBytes);
//   }

//   // Decode & paint helper that handles: pre-scale, decode wait, black-frame fallback via createImageBitmap
//   async function paintImageIntoCanvas(file, dataUrl, canvas, minW, minH) {
//     // 1) Load via <img> and pick scaled dims BEFORE first draw (avoid giant first paint)
//     const img = await loadHTMLImage(dataUrl);
//     const srcW = img.naturalWidth || img.width;
//     const srcH = img.naturalHeight || img.height;

//     // Pre-normalize megapixels
//     const MAX_MP = 12e6; // 12MP
//     const totalPx = srcW * srcH;
//     const preScale = totalPx > MAX_MP ? Math.sqrt(MAX_MP / totalPx) : 1;
//     let cw = Math.max(minW, Math.floor(srcW * preScale));
//     let ch = Math.max(minH, Math.floor(srcH * preScale));

//     canvas.width = cw;
//     canvas.height = ch;

//     // First attempt: draw via <img>
//     let ctx = canvas.getContext("2d");
//     ctx.imageSmoothingEnabled = true;
//     ctx.imageSmoothingQuality = "high";
//     ctx.drawImage(img, 0, 0, cw, ch);

//     // If the draw is blank/black (CMYK/YCCK/progressive edge cases), retry with createImageBitmap
//     if (isLikelyBlank(canvas) && typeof createImageBitmap === "function") {
//       try {
//         const blob = file; // File is already a Blob
//         // Decode oriented, directly resized to canvas dims for speed
//         const bitmap = await createImageBitmap(blob, {
//           imageOrientation: "from-image",
//           resizeWidth: cw,
//           resizeHeight: ch,
//           resizeQuality: "high",
//         });
//         // Clear & draw bitmap
//         ctx.clearRect(0, 0, cw, ch);
//         ctx.drawImage(bitmap, 0, 0, cw, ch);
//         // Close bitmap to free memory
//         if (bitmap.close) bitmap.close();
//       } catch (e) {
//         // If even that fails, leave first draw result (we'll still attempt compression later)
//         console.warn("[image] createImageBitmap fallback failed; continuing with <img> draw", e);
//       }
//     }
//   }

//   // --- Main --------------------------------------------------------------
//   const t0 = nowMs();
//   try {
//     if (!(file instanceof File)) return file;
//     if (file.size <= maxBytes) {
//       console.log(`[image] no compression needed: ${bytesHuman(file.size)} <= ${bytesHuman(maxBytes)}`);
//       return file;
//     }

//     // Prefer WebP if we want to keep alpha from PNG/WebP sources
//     if (keepAlpha && hasAlphaType(file.type)) {
//       mimeType = "image/webp";
//     }

//     const dataUrl = await readAsDataURL(file);

//     // Prepare canvas and paint with robust loader (handles black/blank fallback)
//     const canvas = document.createElement("canvas");
//     await paintImageIntoCanvas(file, dataUrl, canvas, minWidth, minHeight);

//     // 1) Try to fit by quality at current dimensions (fast fitter).
//     let { blob, quality } = await fitByQualityFast(canvas, mimeType, qualityMin, qualityHigh, maxBytes);

//     if (blob && blob.size <= maxBytes && quality >= qualityLow) {
//       const newName = file.name.replace(/\.[^.]+$/, extFor(mimeType));
//       console.log(
//         `[image] compressed (same-dims): ${bytesHuman(file.size)} -> ${bytesHuman(blob.size)} ` +
//         `(${blob.size} bytes), quality=${(quality || 0).toFixed(3)}, ` +
//         `dims=${canvas.width}x${canvas.height}, type=${mimeType}, ` +
//         `target<=${bytesHuman(maxBytes)}, time=${(nowMs() - t0).toFixed(0)}ms`
//       );
//       return new File([blob], newName, { type: mimeType });
//     }

//     // 2) Predictive downscale loop, then re-fit quality
//     while (!blob || blob.size > maxBytes) {
//       const basisSize = (blob && blob.size) || file.size;
//       let s = predictedScale(basisSize, maxBytes);
//       if (s > 0.995) s = 0.985;

//       const shrunk = downscaleCanvas(canvas, s, minWidth, minHeight);
//       if (!shrunk) {
//         const last = await fitByQualityFast(canvas, mimeType, qualityMin, qualityHigh, maxBytes);
//         blob = last.blob;
//         quality = last.quality;
//         break;
//       }

//       const quickQ = Math.min(0.85, Math.max(qualityLow, (quality || 0.8)));
//       const quickBlob = await toBlob(canvas, mimeType, quickQ);
//       if (quickBlob && quickBlob.size <= maxBytes) {
//         blob = quickBlob;
//         quality = quickQ;
//         break;
//       }

//       const attempt = await fitByQualityFast(canvas, mimeType, qualityLow, qualityHigh, maxBytes);
//       blob = attempt.blob;
//       quality = attempt.quality;
//     }

//     if (!blob || blob.size > maxBytes) {
//       const last = await fitByQualityFast(canvas, mimeType, 0.3, qualityLow, maxBytes);
//       if (last.blob) {
//         blob = last.blob;
//         quality = last.quality;
//       }
//     }

//     if (!blob) {
//       blob = await toBlob(canvas, mimeType, Math.max(0.35, qualityMin));
//       quality = Math.max(0.35, qualityMin);
//     }

//     const newName = file.name.replace(/\.[^.]+$/, extFor(mimeType));
//     console.log(
//       `[image] compressed (final): ${bytesHuman(file.size)} -> ${bytesHuman(blob.size)} ` +
//       `(${blob.size} bytes), quality=${(quality || 0).toFixed(3)}, ` +
//       `dims=${canvas.width}x${canvas.height}, type=${mimeType}, ` +
//       `target<=${bytesHuman(maxBytes)}, time=${(nowMs() - t0).toFixed(0)}ms`
//     );
//     return new File([blob], newName, { type: mimeType });
//   } catch (e) {
//     // Tiny fallback encode to avoid blocking UX entirely
//     try {
//       const fallbackCanvas = document.createElement("canvas");
//       const fr = await readAsDataURL(file);
//       const img = await loadHTMLImage(fr);
//       fallbackCanvas.width = Math.max(minWidth, Math.floor(img.width * 0.5));
//       fallbackCanvas.height = Math.max(minHeight, Math.floor(img.height * 0.5));
//       const ctx = fallbackCanvas.getContext("2d");
//       ctx.imageSmoothingEnabled = true;
//       ctx.imageSmoothingQuality = "high";
//       ctx.drawImage(img, 0, 0, fallbackCanvas.width, fallbackCanvas.height);
//       const fallbackQuality = 0.5;
//       const blob = await new Promise((res) =>
//         fallbackCanvas.toBlob((b) => res(b), "image/jpeg", fallbackQuality)
//       );
//       const newName = file.name.replace(/\.[^.]+$/, ".jpg");
//       console.log(
//         `[image] compressed (fallback): ${bytesHuman(file.size)} -> ${bytesHuman(blob.size)} ` +
//         `(${blob.size} bytes), quality=${fallbackQuality.toFixed(3)}, ` +
//         `dims=${fallbackCanvas.width}x${fallbackCanvas.height}, type=image/jpeg, ` +
//         `target<=${bytesHuman(maxBytes)}, time=${(nowMs() - t0).toFixed(0)}ms`
//       );
//       return new File([blob], newName, { type: "image/jpeg" });
//     } catch (e2) {
//       console.warn("[image] compression hard-failed; returning original", e2);
//       return file;
//     }
//   }
// }




// // Version 2
// /**
//  * Compress an image to <= maxBytes (default 1 MB) efficiently and land near the target band.
//  * Strategy
//  *  1) Fast quality fit at current dimensions.
//  *  2) If too big, predictively downscale and re-fit.
//  *  3) If too small (< bandMin), raise quality toward the band (up to qualityCap) without upscaling.
//  *
//  * Guarantees: never returns original if it's over maxBytes (barring catastrophic errors).
//  */
// export async function compressImageSmart(
//   file,
//   {
//     maxBytes = 1000000,
//     mimeType = "image/jpeg",
//     qualityHigh = 0.92,     // fast search upper bound
//     qualityLow = 0.6,       // preferred minimum before downscaling
//     qualityMin = 0.4,       // absolute floor in worst case
//     qualityCap = 0.98,      // max quality when "refining upward" toward the band
//     minWidth = 600,
//     minHeight = 600,
//     keepAlpha = false,
//     bandLowRatio = 0.90,    // aim to be >= 90% of maxBytes
//   } = {}
// ) {
//   // ---------- Helpers ----------
//   const readAsDataURL = (f) =>
//     new Promise((res, rej) => {
//       const fr = new FileReader();
//       fr.onload = () => res(fr.result);
//       fr.onerror = rej;
//       fr.readAsDataURL(f);
//     });

//   const loadHTMLImage = (src) =>
//     new Promise((res, rej) => {
//       const img = new Image();
//       img.decoding = "async";
//       img.onload = async () => {
//         try { if (img.decode) await img.decode(); } catch (_) {}
//         res(img);
//       };
//       img.onerror = rej;
//       img.src = src;
//     });

//   const toBlob = (canvas, type, quality) =>
//     new Promise((res) => canvas.toBlob((b) => res(b), type, quality));

//   const hasAlphaType = (type) => /png|webp/i.test(type);
//   const extFor = (type) =>
//     type === "image/webp" ? ".webp" :
//     type === "image/png"  ? ".png"  :
//     ".jpg";

//   const bytesHuman = (n) => (n >= 1e6 ? (n / 1e6).toFixed(2) + " MB" : (n / 1e3).toFixed(2) + " KB");
//   const nowMs = () => (typeof performance !== "undefined" && performance.now ? performance.now() : Date.now());

//   function isLikelyBlank(canvas) {
//     const w = canvas.width, h = canvas.height;
//     if (!w || !h) return true;
//     const ctx = canvas.getContext("2d", { willReadFrequently: true });
//     const pts = [[w>>1,h>>1],[1,1],[w-2,1],[1,h-2],[w-2,h-2]];
//     for (const [x,y] of pts) {
//       const d = ctx.getImageData(Math.max(0,x), Math.max(0,y), 1, 1).data;
//       if (d[3] !== 0 && (d[0]+d[1]+d[2]) !== 0) return false;
//     }
//     return true;
//   }

//   function predictedScale(currentBytes, targetBytes) {
//     const ratio = Math.max(0.01, Math.min(1, targetBytes / currentBytes));
//     return Math.sqrt(ratio) * 0.98; // slight undershoot avoids oscillation
//   }

//   function downscaleCanvas(canvas, scale, minW, minH) {
//     const nextW = Math.max(minW, Math.floor(canvas.width * scale));
//     const nextH = Math.max(minH, Math.floor(canvas.height * scale));
//     if (nextW === canvas.width && nextH === canvas.height) return false;

//     const tmp = document.createElement("canvas");
//     tmp.width = nextW; tmp.height = nextH;
//     const tctx = tmp.getContext("2d");
//     tctx.imageSmoothingEnabled = true;
//     tctx.imageSmoothingQuality = "high";
//     tctx.drawImage(canvas, 0, 0, nextW, nextH);

//     canvas.width = nextW; canvas.height = nextH;
//     const ctx = canvas.getContext("2d");
//     ctx.imageSmoothingEnabled = true;
//     ctx.imageSmoothingQuality = "high";
//     ctx.clearRect(0, 0, nextW, nextH);
//     ctx.drawImage(tmp, 0, 0, nextW, nextH);
//     return true;
//   }

//   async function fitByQuality(canvas, type, qLo, qHi, targetBytes, epsilonBytes = 8192) {
//     let best = null;
//     let lo = qLo, hi = qHi;

//     let blob = await toBlob(canvas, type, hi);
//     if (blob && blob.size <= targetBytes) return { blob, quality: hi };
//     if (blob) best = blob;

//     while (hi - lo > 0.005) {
//       const mid = (hi + lo) / 2;
//       blob = await toBlob(canvas, type, mid);
//       if (!blob) break;
//       if (!best || blob.size < best.size) best = blob;

//       if (Math.abs(blob.size - targetBytes) <= epsilonBytes) {
//         return { blob, quality: mid };
//       }
//       if (blob.size > targetBytes) hi = mid; else lo = mid;
//     }
//     return { blob: best, quality: (hi + lo) / 2 };
//   }

//   // Fast (2-sample) fit; falls back to binary search as needed
//   async function fitByQualityFast(canvas, type, qLo, qHi, targetBytes, epsilonBytes = 8192) {
//     const q1 = Math.min(qHi, 0.88);
//     const q2 = Math.max(qLo, 0.60);

//     const b1 = await toBlob(canvas, type, q1);
//     if (b1 && b1.size <= targetBytes) return { blob: b1, quality: q1 };

//     const b2 = await toBlob(canvas, type, q2);
//     if (!b1 || !b2 || b1.size === b2.size) {
//       return fitByQuality(canvas, type, qLo, qHi, targetBytes, epsilonBytes);
//     }

//     // log-linear model: ln(size) ≈ m*q + c
//     const m = (Math.log(b2.size) - Math.log(b1.size)) / (q2 - q1);
//     const c = Math.log(b1.size) - m * q1;

//     let qStar = (Math.log(targetBytes) - c) / m;
//     qStar = Math.max(qLo, Math.min(qHi, qStar));

//     let bStar = await toBlob(canvas, type, qStar);
//     if (bStar && Math.abs(bStar.size - targetBytes) <= epsilonBytes) {
//       return { blob: bStar, quality: qStar };
//     }

//     const delta = 0.08;
//     const lo = Math.max(qLo, qStar - delta);
//     const hi = Math.min(qHi, qStar + delta);
//     return fitByQuality(canvas, type, lo, hi, targetBytes, epsilonBytes);
//   }

//   // Raise quality toward band: find the HIGHEST quality <= bandMax (<= maxBytes).
//   // If that still < bandMin, we return the best we can (no upscaling).
//   async function refineUpToBand(canvas, type, qStart, qCap, bandMin, bandMax) {
//     let best = null, bestQ = qStart;

//     // Try cap first
//     let bHi = await toBlob(canvas, type, qCap);
//     if (bHi && bHi.size <= bandMax) {
//       if (bHi.size >= bandMin) return { blob: bHi, quality: qCap };
//       best = bHi; bestQ = qCap; // largest quality allowed but still under bandMin—return after search
//     }

//     // Ensure a starting point
//     let bLo = await toBlob(canvas, type, qStart);
//     if (bLo && bLo.size <= bandMax) {
//       if (!best || bLo.size > best.size) { best = bLo; bestQ = qStart; }
//     }

//     // Binary search for highest quality within bandMax
//     let lo = qStart, hi = qCap;
//     while (hi - lo > 0.005) {
//       const mid = (hi + lo) / 2;
//       const bm = await toBlob(canvas, type, mid);
//       if (!bm) break;

//       if (bm.size <= bandMax) {
//         // allowed — push quality upward
//         if (!best || bm.size > best.size) { best = bm; bestQ = mid; }
//         lo = mid;
//       } else {
//         hi = mid;
//       }
//     }
//     return { blob: best, quality: bestQ };
//   }

//   // Robust paint (decode, pre-scale, black-frame fallback)
//   async function paintImageIntoCanvas(file, dataUrl, canvas, minW, minH) {
//     const img = await loadHTMLImage(dataUrl);
//     const srcW = img.naturalWidth || img.width;
//     const srcH = img.naturalHeight || img.height;

//     // Pre-normalize megapixels (perf)
//     const MAX_MP = 12e6;
//     const totalPx = srcW * srcH;
//     const preScale = totalPx > MAX_MP ? Math.sqrt(MAX_MP / totalPx) : 1;

//     const cw = Math.max(minW, Math.floor(srcW * preScale));
//     const ch = Math.max(minH, Math.floor(srcH * preScale));

//     canvas.width = cw; canvas.height = ch;

//     const ctx = canvas.getContext("2d");
//     ctx.imageSmoothingEnabled = true;
//     ctx.imageSmoothingQuality = "high";
//     ctx.drawImage(img, 0, 0, cw, ch);

//     if (isLikelyBlank(canvas) && typeof createImageBitmap === "function") {
//       try {
//         const bitmap = await createImageBitmap(file, {
//           imageOrientation: "from-image",
//           resizeWidth: cw,
//           resizeHeight: ch,
//           resizeQuality: "high",
//         });
//         ctx.clearRect(0, 0, cw, ch);
//         ctx.drawImage(bitmap, 0, 0, cw, ch);
//         if (bitmap.close) bitmap.close();
//       } catch (e) {
//         console.warn("[image] createImageBitmap fallback failed; continuing", e);
//       }
//     }
//   }

//   // ---------- Main ----------
//   const t0 = nowMs();
//   try {
//     if (!(file instanceof File)) return file;
//     if (file.size <= maxBytes) {
//       console.log(`[image] no compression needed: ${bytesHuman(file.size)} <= ${bytesHuman(maxBytes)}`);
//       return file;
//     }

//     if (keepAlpha && hasAlphaType(file.type)) {
//       mimeType = "image/webp";
//     }

//     const dataUrl = await readAsDataURL(file);
//     const canvas = document.createElement("canvas");
//     await paintImageIntoCanvas(file, dataUrl, canvas, minWidth, minHeight);

//     const bandMin = Math.floor(maxBytes * bandLowRatio);
//     const bandMax = maxBytes;

//     // 1) Fit by quality at current dimensions.
//     let { blob, quality } = await fitByQualityFast(canvas, mimeType, qualityMin, qualityHigh, bandMax);

//     // If we fit and are under the band, try to raise quality up to the band.
//     if (blob && blob.size <= bandMax && blob.size < bandMin) {
//       const up = await refineUpToBand(canvas, mimeType, Math.max(quality, qualityLow), qualityCap, bandMin, bandMax);
//       if (up.blob) { blob = up.blob; quality = up.quality; }
//     }

//     if (blob && blob.size <= bandMax && quality >= qualityLow) {
//       const newName = file.name.replace(/\.[^.]+$/, extFor(mimeType));
//       console.log(
//         `[image] compressed (same-dims): ${bytesHuman(file.size)} -> ${bytesHuman(blob.size)} ` +
//         `(${blob.size} bytes), quality=${(quality || 0).toFixed(3)}, ` +
//         `dims=${canvas.width}x${canvas.height}, type=${mimeType}, ` +
//         `target<=${bytesHuman(maxBytes)}, time=${(nowMs() - t0).toFixed(0)}ms`
//       );
//       return new File([blob], newName, { type: mimeType });
//     }

//     // 2) Predictive downscale loop; always try to refine upward into the band after a successful fit.
//     while (!blob || blob.size > bandMax) {
//       const basisSize = (blob && blob.size) || file.size;
//       let s = predictedScale(basisSize, bandMax);
//       if (s > 0.995) s = 0.985;

//       const shrunk = downscaleCanvas(canvas, s, minWidth, minHeight);
//       if (!shrunk) {
//         const last = await fitByQualityFast(canvas, mimeType, qualityMin, qualityHigh, bandMax);
//         blob = last.blob; quality = last.quality;
//         break;
//       }

//       const quickQ = Math.min(0.85, Math.max(qualityLow, (quality || 0.8)));
//       const quickBlob = await toBlob(canvas, mimeType, quickQ);
//       if (quickBlob && quickBlob.size <= bandMax) {
//         blob = quickBlob; quality = quickQ;

//         if (blob.size < bandMin) {
//           const up = await refineUpToBand(canvas, mimeType, quality, qualityCap, bandMin, bandMax);
//           if (up.blob) { blob = up.blob; quality = up.quality; }
//         }
//         break;
//       }

//       const attempt = await fitByQualityFast(canvas, mimeType, qualityLow, qualityHigh, bandMax);
//       blob = attempt.blob; quality = attempt.quality;

//       if (blob && blob.size <= bandMax && blob.size < bandMin) {
//         const up = await refineUpToBand(canvas, mimeType, Math.max(quality, qualityLow), qualityCap, bandMin, bandMax);
//         if (up.blob) { blob = up.blob; quality = up.quality; }
//       }
//       // loop continues if still > bandMax
//     }

//     // If somehow still above target (min dims), push down further.
//     if (!blob || blob.size > bandMax) {
//       const last = await fitByQualityFast(canvas, mimeType, 0.3, qualityLow, bandMax);
//       if (last.blob) { blob = last.blob; quality = last.quality; }
//     }

//     if (!blob) {
//       blob = await toBlob(canvas, mimeType, Math.max(0.35, qualityMin));
//       quality = Math.max(0.35, qualityMin);
//     }

//     const newName = file.name.replace(/\.[^.]+$/, extFor(mimeType));
//     console.log(
//       `[image] compressed (final): ${bytesHuman(file.size)} -> ${bytesHuman(blob.size)} ` +
//       `(${blob.size} bytes), quality=${(quality || 0).toFixed(3)}, ` +
//       `dims=${canvas.width}x${canvas.height}, type=${mimeType}, ` +
//       `band=[${bytesHuman(bandMin)}..${bytesHuman(bandMax)}], time=${(nowMs() - t0).toFixed(0)}ms`
//     );
//     return new File([blob], newName, { type: mimeType });
//   } catch (e) {
//     // Tiny fallback encode so UX won't break.
//     try {
//       const fallbackCanvas = document.createElement("canvas");
//       const fr = await readAsDataURL(file);
//       const img = await loadHTMLImage(fr);
//       fallbackCanvas.width = Math.max(minWidth, Math.floor(img.width * 0.5));
//       fallbackCanvas.height = Math.max(minHeight, Math.floor(img.height * 0.5));
//       const ctx = fallbackCanvas.getContext("2d");
//       ctx.imageSmoothingEnabled = true;
//       ctx.imageSmoothingQuality = "high";
//       ctx.drawImage(img, 0, 0, fallbackCanvas.width, fallbackCanvas.height);
//       const fallbackQuality = 0.5;
//       const blob = await new Promise((res) =>
//         fallbackCanvas.toBlob((b) => res(b), "image/jpeg", fallbackQuality)
//       );
//       const newName = file.name.replace(/\.[^.]+$/, ".jpg");
//       console.log(
//         `[image] compressed (fallback): ${bytesHuman(file.size)} -> ${bytesHuman(blob.size)} ` +
//         `(${blob.size} bytes), quality=${fallbackQuality.toFixed(3)}, ` +
//         `dims=${fallbackCanvas.width}x${fallbackCanvas.height}, type=image/jpeg`
//       );
//       return new File([blob], newName, { type: "image/jpeg" });
//     } catch (e2) {
//       console.warn("[image] compression hard-failed; returning original", e2);
//       return file;
//     }
//   }
// }



// Version 3

/**
 * Compress an image to <= maxBytes (default 1 MB) efficiently and land near the target band.
 * Strategy
 *  1) Fast quality fit at current dimensions.
 *  2) If too big, predictively downscale and re-fit.
 *  3) If too small (< bandMin), raise quality toward the band (up to qualityCap) without upscaling.
 *
 * Guarantees: never returns original if it's over maxBytes (barring catastrophic errors).
 */
/**
 * Compress an image to <= maxBytes (default 1 MB) and land near a size band.
 * Performance-tuned: createImageBitmap (single decode + resize), encode caching,
 * and detailed logs (encodesRequested/Performed, downscales, MP, etc).
 */
export async function compressImageSmart(
  file,
  {
    maxBytes = 1000000,
    mimeType = "image/jpeg",
    qualityHigh = 0.92,     // fast search upper bound
    qualityLow = 0.6,       // preferred minimum before downscaling
    qualityMin = 0.4,       // absolute floor in worst case
    qualityCap = 0.98,      // max quality when "refining upward" toward the band
    minWidth = 600,
    minHeight = 600,
    keepAlpha = false,
    bandLowRatio = 0.90,    // aim to be >= 90% of maxBytes
    maxMegapixelsCap = 12000000, // decode cap for speed (12 MP); tweak to taste
  } = {}
) {
  // ---------- Helpers ----------
  const bytesHuman = (n) => (n >= 1e6 ? (n / 1e6).toFixed(2) + " MB" : (n / 1e3).toFixed(2) + " KB");
  const nowMs = () => (typeof performance !== "undefined" && performance.now ? performance.now() : Date.now());
  const hasAlphaType = (type) => /png|webp/i.test(type);
  const extFor = (type) =>
    type === "image/webp" ? ".webp" :
    type === "image/png"  ? ".png"  :
    ".jpg";

  // perf stats for logging
  const stats = { encodesRequested: 0, encodesPerformed: 0, downscales: 0, usedBitmap: false };
  const t0 = nowMs();

  // per-call encode cache (avoid duplicate encodes at same w/h/type/q)
  const encodeCache = new Map(); // key -> Blob
  async function toBlobCachedCounted(canvas, type, quality) {
    stats.encodesRequested++;
    const qk = (quality || 0).toFixed(3);
    const key = `${canvas.width}x${canvas.height}:${type}:${qk}`;
    const hit = encodeCache.get(key);
    if (hit) return hit;
    const blob = await new Promise((res) => canvas.toBlob(res, type, quality));
    if (blob) {
      stats.encodesPerformed++;
      encodeCache.set(key, blob);
    }
    return blob;
  }

  function isLikelyBlank(canvas) {
    const w = canvas.width, h = canvas.height;
    if (!w || !h) return true;
    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    const pts = [[w>>1,h>>1],[1,1],[w-2,1],[1,h-2],[w-2,h-2]];
    for (const [x,y] of pts) {
      const d = ctx.getImageData(Math.max(0,x), Math.max(0,y), 1, 1).data;
      if (d[3] !== 0 && (d[0]+d[1]+d[2]) !== 0) return false;
    }
    return true;
  }

  function predictedScale(currentBytes, targetBytes) {
    const ratio = Math.max(0.01, Math.min(1, targetBytes / currentBytes));
    return Math.sqrt(ratio) * 0.98; // slight undershoot avoids oscillation
  }

  function downscaleCanvas(canvas, scale, minW, minH) {
    const nextW = Math.max(minW, Math.floor(canvas.width * scale));
    const nextH = Math.max(minH, Math.floor(canvas.height * scale));
    if (nextW === canvas.width && nextH === canvas.height) return false;

    const tmp = document.createElement("canvas");
    tmp.width = nextW; tmp.height = nextH;
    const tctx = tmp.getContext("2d");
    tctx.imageSmoothingEnabled = true;
    tctx.imageSmoothingQuality = "high";
    tctx.drawImage(canvas, 0, 0, nextW, nextH);

    canvas.width = nextW; canvas.height = nextH;
    const ctx = canvas.getContext("2d");
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";
    ctx.clearRect(0, 0, nextW, nextH);
    ctx.drawImage(tmp, 0, 0, nextW, nextH);

    stats.downscales++;
    return true;
  }

  // Single-decode painter: get source dims via <img> headers, then decode once via bitmap at target size.
  async function paintImageIntoCanvasFast(file, canvas, minW, minH, MAX_MP = 12000000) {
    // get source dimensions quickly
    const url = URL.createObjectURL(file);
    let sw, sh;
    try {
      const img = await new Promise((res, rej) => {
        const i = new Image();
        i.onload = () => res(i); // width/height available without full decode
        i.onerror = rej;
        i.src = url;
      });
      sw = img.naturalWidth || img.width;
      sh = img.naturalHeight || img.height;
    } finally {
      URL.revokeObjectURL(url);
    }

    const totalPx = sw * sh;
    const s = totalPx > MAX_MP ? Math.sqrt(MAX_MP / totalPx) : 1;
    const cw = Math.max(minW, Math.floor(sw * s));
    const ch = Math.max(minH, Math.floor(sh * s));

    if (typeof createImageBitmap === "function") {
      try {
        const bitmap = await createImageBitmap(file, {
          imageOrientation: "from-image",
          resizeWidth: cw,
          resizeHeight: ch,
          resizeQuality: "high",
        });
        canvas.width = cw; canvas.height = ch;
        const ctx = canvas.getContext("2d");
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = (s < 0.7) ? "medium" : "high";
        ctx.drawImage(bitmap, 0, 0, cw, ch);
        if (bitmap.close) bitmap.close();
        stats.usedBitmap = true;
        return { sw, sh, cw, ch, s, MAX_MP };
      } catch (e) {
        // fall through to <img> decode
      }
    }

    // fallback: <img> decode/draw
    const fallbackUrl = URL.createObjectURL(file);
    try {
      const img = await new Promise((res, rej) => {
        const i = new Image();
        i.decoding = "async";
        i.onload = async () => {
          try { if (i.decode) await i.decode(); } catch(_) {}
          res(i);
        };
        i.onerror = rej;
        i.src = fallbackUrl;
      });
      canvas.width = cw; canvas.height = ch;
      const ctx = canvas.getContext("2d", { willReadFrequently: true });
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = (s < 0.7) ? "medium" : "high";
      ctx.drawImage(img, 0, 0, cw, ch);

      // black-frame safety: retry with bitmap if available
      if (isLikelyBlank(canvas) && typeof createImageBitmap === "function") {
        try {
          const bitmap = await createImageBitmap(file, {
            imageOrientation: "from-image",
            resizeWidth: cw,
            resizeHeight: ch,
            resizeQuality: "high",
          });
          ctx.clearRect(0, 0, cw, ch);
          ctx.drawImage(bitmap, 0, 0, cw, ch);
          if (bitmap.close) bitmap.close();
          stats.usedBitmap = true;
        } catch (e) {
          // keep img draw
        }
      }
      return { sw, sh, cw, ch, s, MAX_MP };
    } finally {
      URL.revokeObjectURL(fallbackUrl);
    }
  }

  // Quality fitters (epsilon bumped to 16KB to skip a last tiny probe)
  async function fitByQuality(canvas, type, qLo, qHi, targetBytes, epsilonBytes = 16384) {
    let best = null;
    let lo = qLo, hi = qHi;

    let blob = await toBlobCachedCounted(canvas, type, hi);
    if (blob && blob.size <= targetBytes) return { blob, quality: hi };
    if (blob) best = blob;

    while (hi - lo > 0.005) {
      const mid = (hi + lo) / 2;
      blob = await toBlobCachedCounted(canvas, type, mid);
      if (!blob) break;
      if (!best || blob.size < best.size) best = blob;

      if (Math.abs(blob.size - targetBytes) <= epsilonBytes) {
        return { blob, quality: mid };
      }
      if (blob.size > targetBytes) hi = mid; else lo = mid;
    }
    return { blob: best, quality: (hi + lo) / 2 };
  }

  async function fitByQualityFast(canvas, type, qLo, qHi, targetBytes, epsilonBytes = 16384) {
    const q1 = Math.min(qHi, 0.88);
    const q2 = Math.max(qLo, 0.60);

    const b1 = await toBlobCachedCounted(canvas, type, q1);
    if (b1 && b1.size <= targetBytes) return { blob: b1, quality: q1 };

    const b2 = await toBlobCachedCounted(canvas, type, q2);
    if (!b1 || !b2 || b1.size === b2.size) {
      return fitByQuality(canvas, type, qLo, qHi, targetBytes, epsilonBytes);
    }

    // log-linear model: ln(size) ≈ m*q + c
    const m = (Math.log(b2.size) - Math.log(b1.size)) / (q2 - q1);
    const c = Math.log(b1.size) - m * q1;

    let qStar = (Math.log(targetBytes) - c) / m;
    qStar = Math.max(qLo, Math.min(qHi, qStar));

    let bStar = await toBlobCachedCounted(canvas, type, qStar);
    if (bStar && Math.abs(bStar.size - targetBytes) <= epsilonBytes) {
      return { blob: bStar, quality: qStar };
    }

    const delta = 0.08;
    const lo = Math.max(qLo, qStar - delta);
    const hi = Math.min(qHi, qStar + delta);
    return fitByQuality(canvas, type, lo, hi, targetBytes, epsilonBytes);
  }

  // Raise quality toward band: find HIGHEST quality <= bandMax.
  async function refineUpToBand(canvas, type, qStart, qCap, bandMin, bandMax) {
    let best = null, bestQ = qStart;

    // Try cap first
    let bHi = await toBlobCachedCounted(canvas, type, qCap);
    if (bHi && bHi.size <= bandMax) {
      if (bHi.size >= bandMin) return { blob: bHi, quality: qCap };
      best = bHi; bestQ = qCap;
    }

    // Ensure a starting point
    let bLo = await toBlobCachedCounted(canvas, type, qStart);
    if (bLo && bLo.size <= bandMax) {
      if (!best || bLo.size > best.size) { best = bLo; bestQ = qStart; }
    }

    // Binary-search upward to the limit
    let lo = qStart, hi = qCap;
    while (hi - lo > 0.005) {
      const mid = (hi + lo) / 2;
      const bm = await toBlobCachedCounted(canvas, type, mid);
      if (!bm) break;

      if (bm.size <= bandMax) {
        if (!best || bm.size > best.size) { best = bm; bestQ = mid; }
        lo = mid;
      } else {
        hi = mid;
      }
    }
    return { blob: best, quality: bestQ };
  }

  // ---------- Main ----------
  try {
    if (!(file instanceof File)) return file;
    if (file.size <= maxBytes) {
      console.log(`[image] no compression needed: ${bytesHuman(file.size)} <= ${bytesHuman(maxBytes)}`);
      return file;
    }

    if (keepAlpha && hasAlphaType(file.type)) {
      mimeType = "image/webp";
    }

    const canvas = document.createElement("canvas");
    const meta = await paintImageIntoCanvasFast(file, canvas, minWidth, minHeight, maxMegapixelsCap);
    const bandMin = Math.floor(maxBytes * bandLowRatio);
    const bandMax = maxBytes;

    // 1) Fit by quality at current dimensions.
    let { blob, quality } = await fitByQualityFast(canvas, mimeType, qualityMin, qualityHigh, bandMax);

    // raise into band if undershooting
    if (blob && blob.size <= bandMax && blob.size < bandMin) {
      const up = await refineUpToBand(canvas, mimeType, Math.max(quality, qualityLow), qualityCap, bandMin, bandMax);
      if (up.blob) { blob = up.blob; quality = up.quality; }
    }

    if (blob && blob.size <= bandMax && quality >= qualityLow) {
      const newName = file.name.replace(/\.[^.]+$/, extFor(mimeType));
      console.log(
        `[image] compressed (same-dims): ${bytesHuman(file.size)} -> ${bytesHuman(blob.size)} ` +
        `(${blob.size} bytes), quality=${((quality != null ? quality : 0)).toFixed(3)}, ` +
        `outDims=${canvas.width}x${canvas.height} (${(canvas.width*canvas.height/1e6).toFixed(2)} MP), ` +
        `srcDims=${meta.sw}x${meta.sh} (${(meta.sw*meta.sh/1e6).toFixed(2)} MP), ` +
        `usedBitmap=${stats.usedBitmap}, encodes=${stats.encodesPerformed}/${stats.encodesRequested}, ` +
        `downscales=${stats.downscales}, target<=${bytesHuman(maxBytes)}, time=${(nowMs()-t0).toFixed(0)}ms`
      );
      return new File([blob], newName, { type: mimeType });
    }

    // 2) Predictive downscale loop; raise into band after a successful fit.
    while (!blob || blob.size > bandMax) {
      const basisSize = (blob && blob.size) || file.size;
      let s = predictedScale(basisSize, bandMax);
      if (s > 0.995) s = 0.985;

      const shrunk = downscaleCanvas(canvas, s, minWidth, minHeight);
      if (!shrunk) {
        const last = await fitByQualityFast(canvas, mimeType, qualityMin, qualityHigh, bandMax);
        blob = last.blob; quality = last.quality;
        break;
      }

      const quickQ = Math.min(0.85, Math.max(qualityLow, (quality || 0.8)));
      const quickBlob = await toBlobCachedCounted(canvas, mimeType, quickQ);
      if (quickBlob && quickBlob.size <= bandMax) {
        blob = quickBlob; quality = quickQ;

        if (blob.size < bandMin) {
          const up = await refineUpToBand(canvas, mimeType, quality, qualityCap, bandMin, bandMax);
          if (up.blob) { blob = up.blob; quality = up.quality; }
        }
        break;
      }

      const attempt = await fitByQualityFast(canvas, mimeType, qualityLow, qualityHigh, bandMax);
      blob = attempt.blob; quality = attempt.quality;

      if (blob && blob.size <= bandMax && blob.size < bandMin) {
        const up = await refineUpToBand(canvas, mimeType, Math.max(quality, qualityLow), qualityCap, bandMin, bandMax);
        if (up.blob) { blob = up.blob; quality = up.quality; }
      }
      // loop continues if still > bandMax
    }

    // If somehow still above target (min dims), push down further.
    if (!blob || blob.size > bandMax) {
      const last = await fitByQualityFast(canvas, mimeType, 0.3, qualityLow, bandMax);
      if (last.blob) { blob = last.blob; quality = last.quality; }
    }

    if (!blob) {
      blob = await toBlobCachedCounted(canvas, mimeType, Math.max(0.35, qualityMin));
      quality = Math.max(0.35, qualityMin);
    }

    const newName = file.name.replace(/\.[^.]+$/, extFor(mimeType));
    console.log(
      `[image] compressed (final): ${bytesHuman(file.size)} -> ${bytesHuman(blob.size)} ` +
      `(${blob.size} bytes), quality=${((quality != null ? quality : 0)).toFixed(3)}, ` +
      `outDims=${canvas.width}x${canvas.height} (${(canvas.width*canvas.height/1e6).toFixed(2)} MP), ` +
      `srcDims=${meta.sw}x${meta.sh} (${(meta.sw*meta.sh/1e6).toFixed(2)} MP), ` +
      `usedBitmap=${stats.usedBitmap}, encodes=${stats.encodesPerformed}/${stats.encodesRequested}, ` +
      `downscales=${stats.downscales}, band=[${bytesHuman(Math.floor(maxBytes*bandLowRatio))}..${bytesHuman(maxBytes)}], ` +
      `time=${(nowMs()-t0).toFixed(0)}ms`
    );
    return new File([blob], newName, { type: mimeType });
  } catch (e) {
    // Tiny fallback encode so UX won't break.
    try {
      const url = URL.createObjectURL(file);
      const img = await new Promise((res, rej) => {
        const i = new Image();
        i.decoding = "async";
        i.onload = async () => { try { if (i.decode) await i.decode(); } catch(_) {} res(i); };
        i.onerror = rej;
        i.src = url;
      });
      URL.revokeObjectURL(url);

      const fallbackCanvas = document.createElement("canvas");
      const fw = Math.max(minWidth, Math.floor((img.naturalWidth || img.width) * 0.5));
      const fh = Math.max(minHeight, Math.floor((img.naturalHeight || img.height) * 0.5));
      fallbackCanvas.width = fw;
      fallbackCanvas.height = fh;
      const ctx = fallbackCanvas.getContext("2d");
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
      ctx.drawImage(img, 0, 0, fw, fh);

      const fallbackQuality = 0.5;
      const blob = await new Promise((res) =>
        fallbackCanvas.toBlob((b) => res(b), "image/jpeg", fallbackQuality)
      );
      const newName = file.name.replace(/\.[^.]+$/, ".jpg");
      console.log(
        `[image] compressed (fallback): ${bytesHuman(file.size)} -> ${bytesHuman(blob.size)} ` +
        `(${blob.size} bytes), quality=${fallbackQuality.toFixed(3)}, ` +
        `outDims=${fw}x${fh} (${(fw*fh/1e6).toFixed(2)} MP), usedBitmap=false, ` +
        `encodes=${stats.encodesPerformed}/${stats.encodesRequested}, downscales=${stats.downscales}, ` +
        `time=${(nowMs()-t0).toFixed(0)}ms`
      );
      return new File([blob], newName, { type: "image/jpeg" });
    } catch (e2) {
      console.warn("[image] compression hard-failed; returning original", e2);
      return file;
    }
  }
}

export function base64UrlEncode(str = "") {
  // Convert UTF-8 string → Uint8Array
  const utf8Bytes = new TextEncoder().encode(str);

  // Uint8Array → binary string
  let binary = "";
  for (let i = 0; i < utf8Bytes.length; i++) {
    binary += String.fromCharCode(utf8Bytes[i]);
  }

  // Base64
  const b64 = btoa(binary);

  // Base64URL (RFC 4648 §5)
  return b64
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

export async function sanitizeEncodeImage(file, {
  mimeType = "image/jpeg",
  quality = 0.88,
  maxDim = 2048,      // optional safety cap (keeps detail, avoids massive images)
} = {}) {
  if (!(file instanceof File)) return file;

  // Prefer createImageBitmap (fast, respects EXIF orientation in most modern browsers)
  const bitmap = await createImageBitmap(file);

  // Optionally cap dimensions
  const sw = bitmap.width;
  const sh = bitmap.height;
  const scale = Math.min(1, maxDim / Math.max(sw, sh));
  const cw = Math.max(1, Math.round(sw * scale));
  const ch = Math.max(1, Math.round(sh * scale));

  const canvas = document.createElement("canvas");
  canvas.width = cw;
  canvas.height = ch;

  const ctx = canvas.getContext("2d");
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";
  ctx.drawImage(bitmap, 0, 0, cw, ch);

  // Release bitmap memory
  if (bitmap.close) bitmap.close();

  const blob = await new Promise((res) => canvas.toBlob(res, mimeType, quality));
  if (!blob) return file;

  const newName = file.name.replace(/\.[^.]+$/, mimeType === "image/png" ? ".png" : ".jpg");
  return new File([blob], newName, { type: mimeType });
}

export const checkMarker = (name = "", marker = "") => {
  if (!name || !marker) return false;

  const s = String(name);
  const m = String(marker).toUpperCase();

  // 1. Marker at END
  const endPattern = new RegExp(`\\(${m}\\)\\s*$`, "i");

  // 2. Marker followed by - Shared (middle or end)
  const sharedPattern = new RegExp(`\\(${m}\\)\\s*-\\s*Shared`, "i");

  return endPattern.test(s) || sharedPattern.test(s);
};


// WEBPACK FOOTER //
// ./src/lib/helper.js